<template>
    <b-icon :icon="icon" v-bind="$attrs" v-if="iconLoaded" />
</template>
<script>
import Vue from 'vue'
import { loadIcon } from '@/$plugins/bootstrap/icons/custom-icons'

export default {
  name: 'LazyIcon',
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      iconLoaded: false
    }
  },
  methods: {
    findIconComponent(ctx, iconName) {
      if (!ctx) {
        return null
      }

      var components = (ctx.$options || {}).components
      var iconComponent = components && components[iconName]
      return iconComponent || this.findIconComponent(ctx.$parent, iconName)
    }
  },
  mounted() {
    const iconName = `BIcon${this.icon}`
    if (this.findIconComponent(this, iconName)) {
      this.iconLoaded = true
      return
    }

    this.$nextTick(() => {
      const iconData = loadIcon(this.icon)

      if (iconData) {
        Vue.component(iconData.extendOptions.name, iconData)
        this.iconLoaded = true
      } else {
        console.warn(`Icon '${this.icon}' not found`)
      }
    })
  }
}
</script>
